import type { Dispatch, SetStateAction } from 'react';

import { Box, FormControlLabel, MenuItem, Radio, Select, TextField, Typography } from '@/shared/ui';

const UNIT_LABELS: Record<string, string> = {
  d: 'Day(s)',
  m: 'Month(s)',
  y: 'Year(s)'
};

const rootSx = { display: 'flex', alignItems: 'center', marginBottom: 1.5 };
const textFieldSx = {
  ml: 1,
  width: 42,
  '.MuiFormHelperText-root': {
    position: 'absolute',
    ml: 0,
    bottom: '-22px',
    fontSize: '12px',
    width: 150
  },
  '& .MuiInputBase-input': { p: '7px 7px' }
};
const unitBoxSx = { alignItems: 'center', display: 'flex', ml: 1, backgroundColor: '#272d48' };
const selectSx = {
  '& .MuiMenu-paper': { top: '115px!important', left: '165px!important' },
  '& .MuiInputBase-input': { py: '5.5px', px: '4px', backgroundColor: '#272d48' }
};
const menuItemSx = { fontSize: 14 };
const labelSx = { fontSize: 14, ml: 1 };

const RelativeSelector = ({
  compareTo,
  setCompareTo,
  setComparisonType,
  compareToUnit,
  setCompareToUnit
}: {
  compareTo: string;
  setCompareTo: Dispatch<SetStateAction<string>>;
  setComparisonType: Dispatch<SetStateAction<string>>;
  compareToUnit: string;
  setCompareToUnit: Dispatch<SetStateAction<string>>;
}) => {
  const compareToError =
    !compareTo || compareTo.length < 1 || compareTo === '0' || compareTo === '00';
  return (
    <Box sx={rootSx}>
      <FormControlLabel
        control={<Radio />}
        label='Compare to'
        value='relative'
      />
      <TextField
        error={compareToError}
        helperText={compareToError ? 'Please enter a valid number' : ''}
        size='small'
        slotProps={{
          htmlInput: {
            maxLength: 2,
            inputMode: 'numeric'
          }
        }}
        sx={textFieldSx}
        value={compareTo}
        variant='filled'
        onChange={e => {
          setComparisonType('relative');
          setCompareTo(e.target.value.replaceAll(/\D/g, ''));
        }}
      />
      <Box sx={unitBoxSx}>
        <Select
          MenuProps={{
            disablePortal: true,
            onClick: e => {
              e.preventDefault();
            }
          }}
          size='small'
          sx={selectSx}
          value={compareToUnit}
          variant='filled'
          onChange={e => {
            setComparisonType('relative');
            setCompareToUnit(e.target.value);
          }}
        >
          {Object.entries(UNIT_LABELS).map(([value, label]) => (
            <MenuItem
              key={value}
              sx={menuItemSx}
              value={value}
            >
              {label}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Typography sx={labelSx}>from latest</Typography>
    </Box>
  );
};
export default RelativeSelector;
